<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="reimbursement-invoice-detail-dialog ah-detail-dialog gray-bg"
        top="4vh"
        append-to-body
        :before-close="handleBeforeClose"
        ref="DetailDialog"
    >
        <template slot="title">
            核銷轉開發票 <span class="tioo"># {{ this.form.tioo }}</span>
        </template>

        <!-- 發票主內容 -->
        <InvoiceMainDataView :form="form" :disable-invoice-dialog="disableInvoiceDialog" @stateItemChange="reload('isStatementChanged')" @reload="reload('isInvoiceInfoUpdated')" />

        <!-- 發票開立 -->
        <InvoiceIssueView ref="InvoiceIssueView" :form="form" @openDiscount="onEditDiscountNew" @openVoid="onEditVoidNew" @reload="reload('isInvoiceIssued')" />

        <!-- 折讓 -->
        <InvoiceDiscountView ref="discountView" :invoice="form" @endEdit="onDiscountEdited" @reload="reload('isDiscountSubmitted')" />

        <!-- 作廢 -->
        <InvoiceVoidView ref="voidView" :invoice="form" @endEdit="onVoidEdited" @reload="reload('isVoidSubmitted')" />

        <!-- Footer 功能按鈕 -->
        <div class="detail-row footer right" v-if="action == 'view' && form.tioo != 0">
            <div v-if="isAuth('D23')" style="display: flex; justify-content: space-between">
                <div>
                    <el-button v-loading="isLoading" type="" plain @click="onEdit"> 編輯 </el-button>
                </div>
                <div>
                    <el-button v-if="isDeleteBtnShow" v-loading="isLoading" @click="onDelete">刪除核銷轉開發票作業</el-button>
                </div>
            </div>
        </div>
        <div id="invoice-detail-bottom-scroll-anchor"></div>
    </el-dialog>
</template>
<script>
import InvoiceIssueView from './InvoiceIssueView.vue';
import InvoiceDiscountView from './InvoiceDiscountView.vue';
import InvoiceVoidView from './InvoiceVoidView.vue';
import InvoiceMainDataView from './InvoiceMainDataView.vue';

export default {
    name: 'ReimbursementInvoiceDetailDialog',
    props: ['visible', 'tioo', 'disableInvoiceDialog'],
    components: {
        InvoiceIssueView,
        InvoiceDiscountView,
        InvoiceVoidView,
        InvoiceMainDataView,
    },
    watch: {
        async tioo(newSno) {
            if (newSno) await this.fetchDetailData(newSno);
        },
        visible(newVal) {
            if (!newVal) {
                this.emptyData();
            }
        },
    },
    data() {
        return {
            isInvoiceInfoUpdated: false,
            isDiscountSubmitted: false,
            isInvoiceIssued: false,
            isStatementChanged: false,
            isLoading: false,
            action: 'view', // 檢視:view, 退件:reject, 入帳:paid, 退款折讓:discount, 作廢:void
            form: {},
        };
    },
    computed: {
        isDeleteBtnShow() {
            // 發票已申報
            if (this.form.declared) {
                return false;
            }
            // 折讓已申報
            if ((this.form.foO_DIS === 1 || this.form.foO_DIS === 2) && this.form.foO_DIS_PREFIX_YER !== null) {
                return false;
            }
            // 電子發票
            if (this.form.e_InvoicePlatform) {
                return false;
            }
            return true;
        },
    },
    async created() {
        this.emptyData();
    },
    methods: {
        // 重置
        emptyData() {
            this.action = 'view';
            this.form = {};
            this.isDiscountSubmitted = false;
            this.isInvoiceIssued = false;
            this.isInvoiceInfoUpdated = false;
            this.isStatementChanged = false;
        },

        // 重新載入
        async reload(state) {
            if (state) this[state] = true;
            this.action = 'view';
            await this.fetchDetailData(this.form.tioo);
        },

        // 載入發票單資料
        async fetchDetailData(tioo) {
            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });

            try {
                const resp = await this.$api({
                    url: `/TranInvoice/GetTranInvoiceInfo?tioo=${tioo}`,
                    method: 'GET',
                });

                console.log('Reimbursement Invoice Detail: ', resp);
                this.form = resp.data;
            } finally {
                loading.close();
            }
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除核銷轉開發票作業？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    url: '/TranInvoice/DeleteTranInvoice',
                    method: 'DELETE',
                    data: { tioo: this.form.tioo },
                });

                this.$message({
                    showClose: true,
                    message: '已成功刪除核銷轉開發票作業',
                    type: 'success',
                });
                this.$emit('close', true);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onEdit() {
            this.$router.push({ name: 'reimbursement-invoice-edit', params: { tioo: this.form.tioo } });
        },

        onEditDiscountNew() {
            this.$refs.discountView.startDiscount();
            setTimeout(() => {
                this.scrollToId('reimbursement-invoice-detail-discount-view');
            }, 200);
        },
        onEditVoidNew() {
            this.$refs.voidView.startVoid();
            setTimeout(() => {
                this.scrollToId('reimbursement-invoice-detail-void-view');
            }, 200);
        },
        async onDiscountEdited(refresh) {
            if (refresh) {
                this.isDiscountSubmitted = true;
                await this.reload();
            }
        },
        async onVoidEdited(refresh) {
            if (refresh) {
                this.isVoidSubmitted = true;
                await this.reload();
            }
        },

        // 關閉視窗
        async handleBeforeClose(done) {
            // 正在編輯狀態，彈出是否關閉（防止編輯中誤觸而資料消失）
            if (this.action !== 'view' || this.$refs.discountView.isEditing) {
                try {
                    await this.$confirm('您正在編輯，確認要關閉發票？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });

                    done();
                    this.$emit('close');
                    this.emptyData(); // 為了下次開啟不顯示之前的資料
                } catch (e) {
                    console.log(e);
                }
            } else {
                // 瀏覽狀態，隨時可以關閉
                // 剛才行政審核過, 回表格要重新載入
                if (this.isDiscountSubmitted || this.isInvoiceIssued || this.isInvoiceInfoUpdated || this.isStatementChanged) {
                    this.$emit('close', true);
                } else {
                    this.$emit('close', false);
                }

                this.emptyData(); // 為了下次開啟不顯示之前的資料
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.reimbursement-invoice-detail-dialog .discount-color {
    color: #f00;
}
</style>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.reimbursement-invoice-detail-dialog {
    .ah-status {
        margin-bottom: 10px;
    }

    .amt-summary {
        max-width: 400px;
        text-align: right;
        margin: 30px 0 0 auto;

        @media (max-width: 720px) {
            display: block;

            .spec-item .label {
                text-align: left;
            }
        }
    }
}
</style>
